import { Swiper } from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

Swiper.use([Pagination])
Swiper.use([Autoplay])
Swiper.use([Navigation])

export default () => ({
    carousel: null,

    init() {
        this.carousel = new Swiper('.swiper-image-carousel-instance', {
            slidesPerView: 1,
            spaceBetween: 26,
            speed: 1250,
            effect: "fade",
            loop: true,
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 26,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 26,
                },
            }
        })
    },
})
